/* eslint-disable react/prop-types */
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { safeJsonParse } from '@rcw/utils';

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cart, setCart] = useState(safeJsonParse(localStorage.getItem('cart'), []));

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]); // only run when cart changes

  const addToCart = useCallback((product) => {
    setCart((prevCart) => {
      const alreadyInCart = prevCart.some((p) => p.id === product.id);
      if (alreadyInCart) return prevCart;

      const item = {
        id: product.id,
        title: product.title,
        thumbnail: product.squareThumbnail || product.imageUrl,
        price: product?.discountPrice || product?.Price || product?.price,
        category: product.MenuSection || product.category,
        primary: product?.primary,
        subCategory1: product?.subCategory1,
        IsPromo: product?.IsPromo ?? product?.isPromo ?? false,
        promoLabel: product?.promoLabel,
        originalPrice: product?.Price || product?.price,
        discountPrice: product?.discountPrice,
        discountType: product?.discountType,
        discountValue: product?.discountValue,
      };

      return [...prevCart, item];
    });
  }, []);

  const removeFromCart = useCallback((id) => {
    setCart((prevCart) => prevCart.filter((item) => item.id !== id));
  }, []);

  const clearCart = useCallback(() => {
    setCart([]);
    localStorage.removeItem('cart');
  }, []);

  const contextValue = useMemo(() => ({
    cart,
    addToCart,
    removeFromCart,
    clearCart,
  }), [cart, addToCart, removeFromCart, clearCart]);

  return (
    <CartContext.Provider value={contextValue}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
